import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RampConnectionFieldsFragment = { __typename?: 'RampConnectionData', status: Types.RampConnectionStatus, entityId?: string | null, entityName?: string | null, needsEntitySelection: boolean, copyPurchaseOrders: boolean, connectedAt?: Types.TDateISO | null, connectedBy?: string | null, entities: Array<{ __typename?: 'RampEntityData', id: string, name: string }> };

export type RampConnectionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type RampConnectionQuery = { __typename?: 'Query', rampConnection: { __typename?: 'RampConnectionData', status: Types.RampConnectionStatus, entityId?: string | null, entityName?: string | null, needsEntitySelection: boolean, copyPurchaseOrders: boolean, connectedAt?: Types.TDateISO | null, connectedBy?: string | null, entities: Array<{ __typename?: 'RampEntityData', id: string, name: string }> } };

export const RampConnectionFieldsFragmentDoc = new TypedDocumentString(`
    fragment RampConnectionFields on RampConnectionData {
  status
  entityId
  entityName
  entities {
    id
    name
  }
  needsEntitySelection
  copyPurchaseOrders
  connectedAt
  connectedBy
}
    `, {"fragmentName":"RampConnectionFields"});
export const RampConnectionDocument = new TypedDocumentString(`
    query RampConnection {
  rampConnection {
    ...RampConnectionFields
  }
}
    fragment RampConnectionFields on RampConnectionData {
  status
  entityId
  entityName
  entities {
    id
    name
  }
  needsEntitySelection
  copyPurchaseOrders
  connectedAt
  connectedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    RampConnection: build.query<RampConnectionQuery, RampConnectionQueryVariables | void>({
      query: (variables) => ({ document: RampConnectionDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useRampConnectionQuery, useLazyRampConnectionQuery } = injectedRtkApi;
